// extracted by mini-css-extract-plugin
export default {"preloader":"preloader_preloader__33tiq","rotation":"preloader_rotation__xISvj","anim_rotation":"preloader_anim_rotation__Fn8QJ"};